<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const GROUP_SENDER_REGEX = /^(.+?)\s*\[\d{10,15}\]:\n?/;

const SENDER_COLORS = [
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#0097A7',
  '#00796B',
  '#689F38',
  '#EF6C00',
  '#FF5722',
  '#5D4037',
  '#1565C0',
  '#AD1457',
  '#6A1B9A',
  '#00838F',
  '#2E7D32',
];

function senderColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + hash * 31;
  }
  return SENDER_COLORS[Math.abs(hash) % SENDER_COLORS.length];
}

const { variant } = useMessageContext();

const groupSender = computed(() => {
  if (variant.value !== MESSAGE_VARIANTS.USER) return null;
  const match = props.content.match(GROUP_SENDER_REGEX);
  if (!match) return null;
  return { name: match[1].trim(), color: senderColor(match[1].trim()) };
});

const cleanContent = computed(() => {
  if (groupSender.value) {
    return props.content.replace(GROUP_SENDER_REGEX, '');
  }
  return props.content;
});

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return cleanContent.value;
  }

  return new MessageFormatter(cleanContent.value).formattedMessage;
});
</script>

<template>
  <span>
    <span
      v-if="groupSender"
      class="group-sender-name font-semibold text-xs block mb-0.5"
      :style="{ color: groupSender.color }"
    >
      {{ groupSender.name }}
    </span>
    <span
      v-dompurify-html="formattedContent"
      class="prose prose-bubble"
      :class="{ 'agent-bubble-text': variant === MESSAGE_VARIANTS.AGENT }"
    />
  </span>
</template>

<style scoped>
.agent-bubble-text,
.agent-bubble-text :deep(*) {
  color: white !important;
}
</style>
